







































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { postData } from 'frontend/utils/ajax';
import TrialCancellationActionsUi from 'frontend/views/premium/cancellation/components/TrialCancellationActionsUi.vue';
import {
  SurveyFlags,
  SurveyOption,
  SurveyPostData,
} from 'frontend/views/premium/cancellation/types';

const MIN_OTHER_TEXT_CHARS = 25;

@Component({
  components: {
    TrialCancellationActionsUi,
  },
  computed: {},
})
export default class FlagBasedSurvey extends Vue {
  @Prop({ required: true }) options!: Array<SurveyOption<string>>;
  @Prop({ required: true }) surveyApiEndpointRouteName!: string;
  @Prop() abortBtnText: string | undefined;

  private chosenOption: SurveyOption<string> | null = null;

  private otherOptionText = '';

  private loading = false;

  private chooseOption(option: SurveyOption<string>): void {
    this.chosenOption = option;
    this.$emit('chose-option', option.identifier);
    this.focusOtherTextarea();
  }

  private isChosen(option: SurveyOption<string>): boolean {
    return option.identifier === this.chosenOption?.identifier;
  }

  private get otherOptionChosen(): boolean {
    return this.chosenOption?.identifier === 'other';
  }

  private shouldShowTextareaFor(option: SurveyOption<string>): boolean {
    return this.otherOptionChosen && option.identifier === 'other';
  }

  private focusOtherTextarea(): void {
    // On next tick because the component needs to rerender for the textarea to be visible
    if (!this.otherOptionChosen) {
      return;
    }
    this.$nextTick(() => {
      const otherTextarea = this.$refs.other_textarea as HTMLElement;
      otherTextarea.focus();
    });
  }

  private get canContinue(): boolean {
    return !this.loading && !!this.chosenOption && this.validOtherOption;
  }

  private async abortHandler(): Promise<void> {
    this.loading = true;
    this.$emit('abort');
  }

  private get validOtherOption(): boolean {
    return !this.otherOptionChosen || this.otherOptionRemainingChars === 0;
  }

  private get otherOptionRemainingChars(): number {
    return Math.max(MIN_OTHER_TEXT_CHARS - this.otherOptionText.length, 0);
  }

  private async postSurveyResults(): Promise<void> {
    this.loading = true;

    const endPoint = this.$router.resolve({ name: this.surveyApiEndpointRouteName }).href;

    try {
      await postData(endPoint, this.buildSurveyData());
      this.$emit('survey-posted');
    } catch (e) {
      await this.$store.dispatch('errorModal/showMessage');
      this.loading = false;
    }
  }

  private buildSurveyData(): SurveyPostData {
    const flags = this.options.reduce(
      (accumulator: SurveyFlags, currentOption: SurveyOption<string>) => {
        return {
          ...accumulator,
          ...{ [currentOption.identifier]: this.isChosen(currentOption) },
        };
      },
      {},
    );

    const otherText = this.otherOptionChosen ? this.otherOptionText : '';

    return {
      flags,
      other_text: otherText,
    };
  }
}
